<div [hidden]="!loaded" class="overlay h-100 overflow-auto">
  <div class="header-with-close p-4">
    <div class="tw-min-w-0">
      <p class="header-main-title">Communication history</p>
    </div>

    <button type="button" class="close-header-btn" (click)="close()" aria-label="Close communication history">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="request-revision-email-card tw-mt-5 tw-space-y-4 p-4">
    <div *ngFor="let request of registrant['_source']['revision_requests']" class="history-item">
      <div class="tw-mb-3">
        <p class="subject border">
          <span class="const">Subject:</span>
          <span class="field">{{ request.subject }}</span>
        </p>
      </div>

      <div class="message-wrapper border">
        <div id="toolbar"></div>
        <div class="message">
          <div class="message-editor tw-max-h-72 tw-overflow-auto">
            <div [innerHTML]="request.message"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
